import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ConfigsList from "./List";
import ConfigForm from "./Form";
import Config from "./View";
import NotFound from "../NotFound";

import { PageHeader } from "../Shared";

import { configActions } from "./actions/configs.actions";

export class ManageConfigs extends Component {
  componentDidMount() {
    this.getConfigs();
  }

  getConfigs = () => {
    this.props.getConfigs();
  };

  render() {
    const { fetching, fetched, response, error, match } = this.props;

    return (
      <div className="Configs">
        <Row>
          <Col>
            <PageHeader pageId="configs" pageTitle="Manage Configurations" />
          </Col>
        </Row>

        <div className="content-wrapper">
          <Switch>
            <Route
              exact
              path={match.url}
              render={() => (
                <ConfigsList
                  match={match}
                  data={response}
                  loadData={this.getConfigs}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route
              path={`${match.url}/list`}
              render={() => (
                <ConfigsList
                  match={match}
                  data={response}
                  loadData={this.getConfigs}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route path={`${match.url}/add`} component={ConfigForm} />
            <Route path={`${match.url}/view/:id`} component={Config} />
            <Route path={`${match.url}/edit/:id`} component={ConfigForm} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.configs;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getConfigs: bindActionCreators(
      configActions.getAllConfigs,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageConfigs);
